import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Icon } from "../../icon";
import { PaginationItemContainer, StyledIconsContainer, } from "./pagination-item.styles";
import { KeyBoardKeys } from "../dropdown/keyboardkeys";
export function PaginationItem({ step, onSelect, active, direction, disabled, }) {
    const [focused, setFocused] = useState(false);
    return (_jsx(PaginationItemContainer, Object.assign({ tabIndex: disabled ? -1 : 0, isIcon: step < 0, active: active, onClick: () => {
            if (step) {
                onSelect();
            }
        }, onKeyDown: (event) => {
            if (event.key === KeyBoardKeys.Enter ||
                event.key === KeyBoardKeys.Space ||
                event.key === " ") {
                onSelect();
            }
        }, onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), focused: focused }, { children: step > 0 ? (String(step)) : (_jsxs(_Fragment, { children: [_jsx(StyledIconsContainer, { children: _jsx(Icon, { symbol: direction === "left"
                            ? "DoubleChevronLeft"
                            : "DoubleChevronRight" }) }), _jsx(StyledIconsContainer, { children: "..." })] })) })));
}
